export default __webpack_public_path__ + "static/media/redirectBanner.77077c24.jpeg";